var calculateFixedTrackSize = function (ref) {
        var max = ref.max;
        var min = ref.min;
        var smallStep = ref.smallStep;
        var fixedTickWidth = ref.fixedTickWidth;

        return ((max - min) / smallStep) * fixedTickWidth;
};

var calculateTrackSize = function (wrapperWidth, offset, showButtons) {
    if ( showButtons === void 0 ) showButtons = true;

    var BUTTONS_COUNT = 2;
    var trackOffset = showButtons ? parseFloat(offset, 10) * BUTTONS_COUNT : 0;
    var trackWidth = wrapperWidth - trackOffset;

    return trackWidth;
};

var calculateTicksCount = function (max, min, smallStep) {
        if ( max === void 0 ) max = 0;
        if ( min === void 0 ) min = 0;
        if ( smallStep === void 0 ) smallStep = 1;

        return calculateAreasCount(max, min, smallStep) + 1;
};

var calculateAreasCount = function (max, min, smallStep) {
    if ( max === void 0 ) max = 0;
    if ( min === void 0 ) min = 0;
    if ( smallStep === void 0 ) smallStep = 1;

    if (smallStep <= 0 ) {
        throw new Error("Invalid argument: smallStep must be a positive number");
    }

    return Math.floor(Math.abs(min - max) / smallStep);
};

var calculateValueFromTick = function (index, ref) {
    var max = ref.max;
    var min = ref.min;
    var smallStep = ref.smallStep;
    var reverse = ref.reverse;
    var vertical = ref.vertical;

    var value = min + (index * smallStep);

    return vertical || reverse ? Math.abs(value - max) : value;
};

var calculateValueFromTrack = function (clientRect, pageOffset, props) {
    var length, wrapperOffset;

    if (props.vertical) {
        var top = clientRect.top;
        var bottom = clientRect.bottom;
        length = top - bottom;
        wrapperOffset = pageOffset.pageY - bottom;
    } else {
        var left = clientRect.left;
        var right = clientRect.right;
        length = right - left;
        wrapperOffset = pageOffset.pageX - left;
    }

    return valueFromTrack(props, wrapperOffset, length);
};

var valueFromTrack = function (props, wrapperOffset, length) {
    var max = props.max;
    var min = props.min;
    var reverse = props.reverse;
    var smallStep = props.smallStep;
    var distance = max - min;
    var clickOffset = wrapperOffset / length;
    var maxTickValue = distance - (distance % smallStep);
    var maxOffset = (100 / distance) * maxTickValue / 100;
    var absValue = (wrapperOffset / length) * distance;
    var value = max;

    if (clickOffset < maxOffset) {
        value = reverse ? max - absValue : absValue + min;
    }

    return snapValue(extendProps(props, { value: value }));
};

var calculateTickSizes = function (trackSize, min, max, step) {
    var elementCount = Math.floor((max - min) / step) + 1;
    var distStep = trackSize / (max - min);
    var result = [];
    var usedSpace = 0;
    var endPoint = 0;

    for (var i = 0; i < elementCount; i++) {
        if (i === 0 || i === elementCount - 1) {
            endPoint += (step / 2) * distStep;
        } else {
            endPoint += step * distStep;
        }

        var size = Math.round(endPoint - usedSpace);

        result.push(size);

        usedSpace += size;
    }

    return result;
};

var calculateHandlePosition = function (ref) {
    var handleWidth = ref.handleWidth;
    var trackWidth = ref.trackWidth;
    var min = ref.min;
    var max = ref.max;
    var reverse = ref.reverse;
    var value = ref.value;

    var halfHandleWidth = Math.floor(handleWidth / 2);
    var step = trackWidth / Math.abs(max - min);
    var pos = step * (value - min);
    if (reverse) {
        pos = trackWidth - pos;
    }

    return Math.floor(pos - halfHandleWidth);
};

var decreaseValueToStep = function (ref) {
    var max = ref.max;
    var min = ref.min;
    var smallStep = ref.smallStep;
    var value = ref.value;

    var result;
    if (value % smallStep === 0) {
        result = value - smallStep;
    } else {
        result = value - (value % smallStep);
    }
    return trimValue(max, min, result);
};

var increaseValueToStep = function (ref) {
    var max = ref.max;
    var min = ref.min;
    var smallStep = ref.smallStep;
    var value = ref.value;

    var result = value - (value % smallStep) + smallStep;

    return trimValue(max, min, result);
};

var snapValue = function (props) {
    var smallStep = props.smallStep;
    var value = props.value;
    var left = decreaseValueToStep(props);
    var right = increaseValueToStep(props);

    if (value % smallStep === 0) {
        return value;
    }

    if (right - value <= smallStep / 2) {
        return right;
    }

    return left;
};

var trimValue = function (max, min, value) {
    if (value > max) {
        return max;
    }

    if (value < min) {
        return min;
    }

    return value;
};

var identity = function (value) { return value; };

var extendProps = function (target) {
    var sources = [], len = arguments.length - 1;
    while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];

    return Object.assign.apply(Object, [ {}, target ].concat( sources ));
};

export default {
    calculateFixedTrackSize: calculateFixedTrackSize,
    calculateValueFromTick: calculateValueFromTick,
    calculateValueFromTrack: calculateValueFromTrack,
    calculateTrackSize: calculateTrackSize,
    calculateTicksCount: calculateTicksCount,
    calculateTickSizes: calculateTickSizes,
    calculateHandlePosition: calculateHandlePosition,
    decreaseValueToStep: decreaseValueToStep,
    identity: identity,
    increaseValueToStep: increaseValueToStep,
    trimValue: trimValue,
    snapValue: snapValue,
    valueFromTrack: valueFromTrack
};

//# sourceMappingURL=SliderUtil.js.map



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@telerik/kendo-inputs-common/dist/es/SliderUtil.js
// module id = ../../../../@telerik/kendo-inputs-common/dist/es/SliderUtil.js
// module chunks = 3